import { RootState } from "../../../rootReducer";

export const selectIsLoading = (state: RootState) => state.venuesList.loading;
export const selectErrorMessage = (state: RootState) => state.venuesList.error;
export const venuesListResponse = (state: RootState) =>
  state.venuesList.venuesListResponse;
